import React from 'react'
import '../../Style.css';
import '../../Media-styles.css';

import '../Styles/ProGrid.css'

import Slider from './Slider';

import ProjectFeatures from '../../../components/Project-Series/Project3/Features';


function ProjectThree() {
    return (
        <>


            <div className='inner_container'>


                <div className='pro-inner-body-container'>
                    <div className='inner_body'>
                        <section className="section-container">

                            <div className="section-body">
                                <div className="section-left">
                                   
                                    <Slider />


                                </div>

                                <div className="section-right">
                                    
                                    <h2 className="product-feature">
                                    UWA University Hall
                                    </h2>

                                    <ProjectFeatures />

                                </div>
                            </div>
                          
                        </section>

                    </div>

                </div>
            </div>

     
        </>
    )
}

export default ProjectThree;
